import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/analytics/savings");

export const Route = createFileRoute("/analytics/savings")({
  head: () => ({
    meta: [
      { title: "Savings — LevelLoad" },
      { name: "description", content: "Savings — LevelLoad transport planning." },
      { property: "og:title", content: "Savings — LevelLoad" },
      { property: "og:description", content: "Savings — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
